const url = '/markets';
const Provider = 'Markets';
const dbModel = 'Markets';

export { url, Provider, dbModel };
